<template lang="pug">
  .mx-2(:class="{ 'mx-16': $vuetify.breakpoint.mdAndUp }")
    .d-flex.justify-center.py-16(v-if="loading")
      v-progress-circular(indeterminate color="primary")
    v-alert.mt-8(v-else-if="!article" type="info" outlined) 找不到這篇文章，可能尚未發佈或已被移除。
    template(v-else)
      .article-media
        .article-video(v-if="videoEmbed")
          iframe(
            :src="videoEmbed.src"
            :title="videoEmbed.title"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
            loading="eager"
            referrerpolicy="strict-origin-when-cross-origin"
          )
        v-img(v-else :src="articleImageUrl(article)" eager max-height="620" contain class="grey lighten-4")
      .mt-6.mx-2.text-h5 {{ article.title }}
      .mt-2.mx-4
        .d-flex.align-center.text-subtitle-1.grey--text
          v-icon(size="14") mdi-calendar-blank-outline
          span.ml-1 {{ article.post_date }}
          v-icon.ml-3(size="14") mdi-eye
          span.ml-1 {{ article.read_num }}{{ $t('News_4') }}
      .mt-6.mx-2.text-body-1.article-content {{ article.content }}
      .mt-6.mx-2(v-if="safeExternalVideoUrl && !videoEmbed")
        v-btn(:href="safeExternalVideoUrl" target="_blank" rel="noopener noreferrer" outlined color="primary")
          v-icon(left) mdi-play-circle-outline
          | 觀看影片
      .mt-3.mx-2.text-caption.grey--text(v-else-if="videoEmbed")
        | 如果播放器無法顯示，可能是影片並非公開內容。
        a.ml-1(:href="videoEmbed.originalUrl" target="_blank" rel="noopener noreferrer") 在新分頁開啟
      .mt-10.mb-16.mx-2
        v-chip.grey--text.text--darken-1.mr-2(v-for="tag in article.tags" :key="tag") {{ tag }}
</template>

<script>
import {
  articleImageUrl,
  articleVideoEmbed,
  fetchArticle,
  safeVideoUrl,
} from "@/services/articles";

export default {
  name: "NewsInfo",

  data() {
    return {
      article: null,
      loading: true,
    };
  },

  computed: {
    videoEmbed() {
      return this.article ? articleVideoEmbed(this.article.video_url) : null;
    },
    safeExternalVideoUrl() {
      return this.article ? safeVideoUrl(this.article.video_url) : "";
    },
  },

  methods: {
    articleImageUrl,
    async loadArticle() {
      this.loading = true;
      try {
        this.article = await fetchArticle(this.$route.params.uid);
      } finally {
        this.loading = false;
      }
    },
  },

  watch: {
    "$route.params.uid": "loadArticle",
  },

  mounted() {
    this.loadArticle();
  },
};
</script>

<style lang="sass" scoped>
.article-media
  width: 100%

.article-video
  position: relative
  width: 100%
  padding-top: 56.25%
  overflow: hidden
  background: #000

  iframe
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    border: 0

.article-content
  white-space: pre-line
  line-height: 1.9
</style>
